export default "__VITE_ASSET__BdSC$8QF__"